import Dbm from "dbm";

let fullSetup = function() {

    let decodePrefix = "graphApi/decode/";

    {
        let name = "example";
        let currentDecoder = new Dbm.graphapi.webclient.decode.DecodeBaseObject();
        currentDecoder.item.setValue("copyLink", ["property1"]);
        currentDecoder.item.setValue("copyLinks", ["property2"]);
        currentDecoder.item.setValue("encodingType", name);
        currentDecoder.item.register(decodePrefix + name);
    }

    Dbm.graphapi.webclient.decode.setupDefaultDecoder("highscore", ["name", "score"], ["player"], []);
}

export {fullSetup};